import React from 'react';
import ComponentLoading from '../Loading/ComponentLoading';

type Props = {
  render: Function,
  isFetching?: Boolean,
  renderFetching?: Function,
  isError?: Boolean,
  renderError?: Function,
};

function ApiResponseComponent(props: Props) {
  const { isFetching, renderFetching, isError, renderError, render } = props;
  if (isFetching) {
    return renderFetching();
  }
  if (isError) {
    return renderError();
  }
  return render();
}

ApiResponseComponent.defaultProps = {
  isError: false,
  renderError: null,
  isFetching: false,
  renderFetching: () => <ComponentLoading />,
};

export default ApiResponseComponent;
